export const loadRazorpayScript = () =>
  new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(true);

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      console.error("Failed to load Razorpay script");
      reject(new Error("Razorpay SDK failed to load."));
    };
    document.body.appendChild(script);
  });

export const buildRazorpayOptions = ({
  key,
  order,
  currency,
  registrationDbId,
  fallbackRegistrationDbId,
  formData,
  handler,
}) => ({
  key,
  amount: order.amount,
  currency: order.currency || currency,
  name: "Conference Registration",
  description: "Event registration fee",
  order_id: order.id || order.orderId,
  notes: {
    registrationId: registrationDbId || fallbackRegistrationDbId || "",
  },
  handler,
  prefill: {
    name: `${formData.firstName} ${formData.lastName}`,
    email: formData.email,
    contact: formData.mobile,
  },
  theme: { color: "#1976d2" },
});
